
import { 
    ActionTypes, 
    createDataType,
    getContentType,
    getTeacherContentType,
    setUserInfoType,
    getUserActivityType,
    updateUserActivityType,
    getStudentScoresType,
    groupLessonsType,
    submitMessageType,
    reportEventType,
    setDataType,
  } from "./types";
  


  // create data


  export const CREATE_DATA_SAGA = (payload: createDataType) => ({
    type: 'CREATE_DATA_SAGA',
    payload: payload
  });



  // get things from db
  


  export const GET_USER_INFO_SAGA = () => ({
    type: 'GET_USER_INFO_SAGA',
    payload: ''
  });

  export const GET_CONTENT_SAGA = (payload: getContentType) => ({
    type: 'GET_CONTENT_SAGA',
    payload: payload
  });

  export const GET_TEACHER_CONTENT_SAGA = (payload: getTeacherContentType) => ({
    type: 'GET_TEACHER_CONTENT_SAGA',
    payload: payload
  });

  export const GET_USER_ACTIVITY_SAGA = (payload: getUserActivityType) => ({
    type: 'GET_USER_ACTIVITY_SAGA',
    payload: payload
  });

  export const GET_TOTAL_LIKES_SAGA = () => ({
    type: 'GET_TOTAL_LIKES_SAGA',
    payload: true
  });

  export const GET_STUDENT_SCORES_SAGA = (payload: getStudentScoresType) => ({
    type: 'GET_STUDENT_SCORES_SAGA',
    payload: payload
  });

  
  export const GET_GROUP_LESSONS_SAGA = (payload: { groupName: string }) => ({
    type: 'GET_GROUP_LESSONS_SAGA',
    payload: payload
  });


  export const GET_USER_LESSONS_SAGA = (payload: string): ActionTypes => ({
    type: 'GET_USER_LESSONS_SAGA',
    payload: payload
  });

  export const GET_GROUP_CONTENT_SAGA = (payload: string): ActionTypes => ({
    type: 'GET_GROUP_CONTENT_SAGA',
    payload: payload
  });



  export const GET_WHATSAPP_STATUS_SAGA = (payload: string): ActionTypes => ({
    type: 'GET_WHATSAPP_STATUS_SAGA',
    payload: payload
  });


  export const GET_TUTORIALS_SAGA = () => ({
    type: 'GET_TUTORIALS_SAGA',
    payload: true
  });




  // set things in reducer


  export const SET_DATA = (payload: setDataType ) => ({
    type: 'SET_DATA',
    payload: payload
  })
  

  export const SET_ENCODED_INFO = (payload: { [key: string]: string } ) => ({
    type: 'SET_ENCODED_INFO',
    payload: payload
  });


  export const SET_USER_ACTIVITY = (payload: { [key: string]: any }[]) => ({
    type: 'SET_USER_ACTIVITY',
    payload: payload
  });



  export const SET_TOTAL_LIKES = (payload: any[]): ActionTypes => ({
    type: 'SET_TOTAL_LIKES',
    payload: payload
  });

  export const SET_STUDENT_SCORES = (payload: any[]): ActionTypes => ({
    type: 'SET_STUDENT_SCORES',
    payload: payload
  });

  
  export const SET_CONTENT = (payload: { [key: string]: any }) => ({
    type: 'SET_CONTENT',
    payload: payload
  });


  export const SET_TUTORIALS = (payload: { [key: string]: any }[]) => ({
    type: 'SET_TUTORIALS',
    payload: payload
  });

  
  export const SET_USER_INFO = (payload: setUserInfoType): ActionTypes => ({
    type: 'SET_USER_INFO',
    payload: payload
  });


  export const SET_GROUP_LESSONS = (payload: groupLessonsType): ActionTypes => ({
    type: 'SET_GROUP_LESSONS',
    payload: payload
  });

  


  export const SET_GROUP_CONTENT = (payload: { [key: string]: any; }): ActionTypes => ({
    type: 'SET_GROUP_CONTENT',
    payload: payload
  });


  
  export const SET_GROUP_LESSONS_LOADER = (): ActionTypes => ({
    type: 'SET_GROUP_LESSONS_LOADER',
    payload: true
  });


  export const SET_USER_LESSONS = (payload: { [key: string]: any }[]): ActionTypes => ({
    type: 'SET_USER_LESSONS',
    payload: payload
  });


  
  export const SET_USER_LESSONS_LOADER = (): ActionTypes => ({
    type: 'SET_USER_LESSONS_LOADER',
    payload: true
  });



  

  // update things in reducer

  
  
  export const UPDATE_ACTIVITY = (): ActionTypes => ({
    type: 'UPDATE_ACTIVITY',
    payload: true
  });


  export const UPDATE_USER_ACTIVITY_SAGA = (payload: updateUserActivityType): ActionTypes => ({
    type: 'UPDATE_USER_ACTIVITY_SAGA',
    payload: payload
  });


  export const UPDATE_TOTAL_LIKES = (): ActionTypes => ({
    type: 'UPDATE_TOTAL_LIKES',
    payload: true
  });


  export const UPDATE_STUDENT_SCORES = (payload: boolean): ActionTypes => ({
    type: 'UPDATE_STUDENT_SCORES',
    payload: payload
  });

  
  export const UPDATE_GUEST_DATA = (): ActionTypes => ({
    type: 'UPDATE_GUEST_DATA',
    payload: true
  });


  export const UPDATE_HASH = (payload: { [key: string]: any }): ActionTypes => ({
    type: 'UPDATE_HASH',
    payload: payload
  });

  


  // other actions


  export const CREATE_ERROR = () => ({
    type: 'CREATE_ERROR',
    payload: true
  });

  
  export const CHANGE_MODAL_STATE = (payload: string) => ({
    type: 'CHANGE_MODAL_STATE',
    payload: payload
  });  


  export const REGISTER_EMAIL_SAGA = (payload: { userName: string, userEmail: string }): ActionTypes => ({
    type: 'REGISTER_EMAIL_SAGA',
    payload: payload
  });


  export const SUBMIT_MESSAGE_SAGA = (payload: submitMessageType): ActionTypes => ({
    type: 'SUBMIT_MESSAGE_SAGA',
    payload: payload
  });


  export const SET_WHATSAPP_REMINDER_SAGA = (payload: { userEmail: string, disable: boolean }): ActionTypes => ({
    type: 'SET_WHATSAPP_REMINDER_SAGA',
    payload: payload
  });


  export const REPORT_EVENT_SAGA = (payload: reportEventType): ActionTypes => ({
    type: 'REPORT_EVENT_SAGA',
    payload: payload
  });

  export const RECORD_ERROR_SAGA = (payload: { data: { [key: string]: any }, endpoint: string}): ActionTypes => ({
    type: 'RECORD_ERROR_SAGA',
    payload: payload
  });

  export const JOIN_LESSON_SAGA = (payload: number): ActionTypes => ({
    type: 'JOIN_LESSON_SAGA',
    payload: payload
  });

  export const SET_SESSION_DURATION = (payload: number): ActionTypes => ({
    type: 'SET_SESSION_DURATION',
    payload: payload
  });

  export const SET_IDLE_TIME = (payload: number): ActionTypes => ({
    type: 'SET_IDLE_TIME',
    payload: payload
  });

  

  
  


  // log out



  export const LOG_OUT_SAGA = (): ActionTypes => ({
    type: 'LOG_OUT_SAGA',
    payload: ''
  });


  export const LOG_IN_SAGA = (): ActionTypes => ({
    type: 'LOG_IN_SAGA',
    payload: ''
  });



  
 
  export const DO_TEST = (): ActionTypes => ({
    type: 'DO_TEST',
    payload: ''
  });


   
  
  
  